import Urls from "../../urlLink";
import { createApiClient, createApiService } from "../../utils/apiClientFactory";

const crmClient = createApiClient(Urls.crmApiUrl);
const commonClient = createApiClient(Urls.smcApiUrl);

const crmService = createApiService(crmClient, {
  getSchool: ["get", "/Index/getSchoolApi"],
  getLinkman: ["get", "/Index/getLinkmanApi"],
  getMarketer: ["get", "/Index/getMarketerApi"],
  getSchooOrganizel: ["get", "/Index/getSchooOrganizelApi"],
  getCrmLevel: ["get", "/Module/getCrmLevel"],
  ChangeUrl: ["get", "/Module/ChangeUrl"],
  getModule: ["get", "/Module"],
  getLowModuleList: ["get", "/Module/getLowModuleList"],
});

const commonService = createApiService(commonClient, {
  getDistrict: ["get", "/Common/getDistrictApi"],
  getProvince: ["get", "/Common/getProvinceApi"],
  getCity: ["get", "/Common/getCityApi"],
  getModuleHandbookApi: ["get", "/Common/getModuleHandbookApi"],
  getModuleHandbookOneApi: ["get", "/Common/getModuleHandbookOneApi"],
});

const storeHeard = Object.assign({}, crmService, commonService);

export default storeHeard;
